export default {
	init() {
		const $form = $('#tr-meni-form')
		if ($form.length === 0) return

		const formEl = $form.get(0)
		const action = $form.find('input[name="action"]').val()
		if (action !== 'tr_save_meni') return

		$form.on('submit', function(e) {
			e.preventDefault()

			const $submitBtn = $form.find('button[type="submit"]')
			if (formEl && !formEl.checkValidity()) {
				formEl.reportValidity()
				return
			}
			const form_error_element = $form.find('.form-response.error')
			form_error_element.addClass('hidden')
			$submitBtn.prop('disabled', true)

			const formData = new FormData(this)

			// Debug form data
			let objectContext = {}
			for (const [key, value] of formData) {
				objectContext[key]=value
			}
			// console.log(objectContext)

			$.ajax({
				url: my_ajax_object.ajax_url,
				type: 'POST',
				data: formData,
				processData: false,
				contentType: false,
				dataType: 'json',
				success: function (response) {
					if (response && response.success) {
						form_error_element.text('Podatki so shranjeni. Preusmerjamo vas na naslednji korak...').removeClass('hidden text-red border-red').addClass('success text-blue border-blue').show()

						setTimeout(function() {
							window.location.href = response.data.redirect;
							$submitBtn.prop('disabled', false)
						}, 1000)
					} else {
						let iks_error = $form.find('.iks_error')
						if (response.data.error_code === 333) {
							iks_error.removeClass('hidden')
							iks_error.find('.iks_error_message').text(response.data.error)
						} else {
							iks_error.addClass('hidden')
							form_error_element.text(response.data.error).removeClass('hidden')
						}
						$submitBtn.prop('disabled', false)
					}

				},
				error: function (jqXHR, textStatus, errorThrown) {
					let msg = 'Napaka pri shranjevanju. Osvežite stran in poskusite znova.'
					if (jqXHR.responseJSON && jqXHR.responseJSON.data) {
						msg = jqXHR.responseJSON.data
					}

					form_error_element.text(msg).removeClass('hidden')
					$submitBtn.prop('disabled', false)
				}
			})
		})
	}
}
